import { render, staticRenderFns } from "./AnnualUpdate.vue?vue&type=template&id=4689a19e&scoped=true&"
import script from "./AnnualUpdate.vue?vue&type=script&lang=js&"
export * from "./AnnualUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AnnualUpdate.vue?vue&type=style&index=0&id=4689a19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689a19e",
  null
  
)

export default component.exports